<script setup>
const { t, locale } = useI18n();
const route = useRoute();
const gtm = useGtm();
const localePath = useLocalePath();

import { pageTransition } from '~/helpers/animations/animations';
definePageMeta({
  pageTransition: pageTransition,
});

const breadcrumbs = ref([{ title: t('pages.club.index.title') }]);
const routeId = route.name;

const cards = ref([
  {
    id: 'card1',
    slug: 'pritel',
    name: t('assets.data.cards-1-name'),
    price: 1150,
    image: '/img/club/friend.png',
    points: t('assets.data.cards-1-points'),
    link: true,
    type: 'friend',
  },
  {
    id: 'card2',
    slug: 'pritel-plus',
    name: t('assets.data.cards-2-name'),
    price: 1750,
    image: '/img/club/friend-plus.png',
    points: t('assets.data.cards-2-points'),
    link: true,
    type: 'friend-plus',
  },
  {
    id: 'card3',
    slug: 'junior',
    name: t('assets.data.cards-3-name'),
    price: 650,
    image: '/img/club/junior.png',
    points: t('assets.data.cards-3-points'),
    link: true,
    type: 'junior',
  },
  {
    id: 'card4',
    slug: 'senior',
    name: t('assets.data.cards-4-name'),
    price: 550,
    image: '/img/club/senior.png',
    points: t('assets.data.cards-4-points'),
    link: true,
    type: 'senior',
  },
  {
    id: 'card5',
    slug: 'podporovatel',
    name: t('assets.data.cards-5-name'),
    price: 5000,
    image: '/img/club/supporter.png',
    points: t('assets.data.cards-5-points'),
    link: true,
    type: 'podporovatel',
  },
]);

const pageQuery = gql`
  query pageData($routeId: String!) {
    page(route_id: $routeId) {
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      name
      perex
      content
    }
  }
`;

const { data } = await useAsyncQuery(pageQuery, { routeId: routeId });

const pageData = computed(() => data.value?.page);
// const gtmTrack = () => {
//   // Assuming this.gtmTrack is part of the trackingMixin
//   gtmTrack({ event: 'club_visit', url: window.location.href.replace(window.location.origin, '') })
// }

onMounted(() => {
  gtm.trackEvent({
    event: 'club_visit',
    url: window.location.href.replace(window.location.origin, ''),
  });
});

useHead({
  title: pageData.value ? (pageData.value.seo_meta_title ? pageData.value.seo_meta_title : pageData.value.name) : t('pages.club.index.title'),
  description: pageData.value && pageData.value.seo_meta_description ? pageData.value.seo_meta_description : null,
  keywords: pageData.value && pageData.value.seo_meta_keywords ? pageData.value.seo_meta_keywords : null,
});
</script>

<template>
  <main class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <div v-if="pageData" class="container-content mt-5">
      <h1 class="heading">{{ pageData.name }}</h1>
      <div ref="perex">
        <p v-if="pageData.perex" class="text text--2 mt-5 mb-5" v-html="pageData.perex" />
      </div>
      <DynamicPageContent v-if="pageData.content" :content="pageData.content" class="mt-5" />

      <nuxt-link :to="localePath({ name: 'slug', params: { slug: locale === 'en' ? 'membership-terms' : 'podminky-clenskeho-programu-klubu-pratel-ngp' } })" class="button button--medium mt-4 mr-2">{{
        t('pages.club.index.conditions-button')
      }}</nuxt-link>
      <nuxt-link :to="localePath({ name: 'slug', params: { slug: locale === 'en' ? 'frequently-asked-questions-faq' : 'nejcastejsi-dotazy' } })" class="button button--medium mt-4 mr-2">{{
        t('pages.club.index.faq-button')
      }}</nuxt-link>

      <nuxt-link :to="localePath({ name: 'events-category', params: { category: locale === 'en' ? 'members-events' : 'akce-klubu-pratel' } })" class="button button--medium mt-4">{{
        t('pages.club.index.events-button')
      }}</nuxt-link>
    </div>
    <h2 class="heading heading--2 heading--thin mt-5">
      {{ t('pages.club.index.subheading') }}
    </h2>
    <div class="container-content mt-5">
      <ClubCard
        v-for="card in cards"
        :id="card.id"
        :key="card.id"
        :slug="card.slug"
        ref="card"
        :name="card.name"
        :price="card.price"
        :image="useGetImageUrl(card.image, 420)"
        :warning="card.warning"
        :link="card.link ? true : false"
        :selected="card.selected"
      >
        <div v-html="card.points" />
      </ClubCard>
      <div ref="cta">
        <CTABox class="mt-5">
          <h2 class="heading heading--3 heading--upper" v-html="t('pages.club.index.cta-3')" />
          <p class="text--2 mt-3" v-html="t('pages.club.index.cta-4')" />
          <nuxt-link :to="localePath('about-support')" class="button button--medium mt-4">{{ t('pages.club.index.cta-button') }}</nuxt-link>
        </CTABox>
      </div>
    </div>
  </main>
</template>
